<style scoped>
.timesheet {
	background-color: white;
	border-radius: 4px;

	margin-bottom: 5px;
}

.timesheet_top {
	background-color: #00AAFD;
	border-radius: 4px 4px 0px 0px;
	width: 100%;
	height: 5px;

}

.timesheet_content {
	padding-left: 15px;
	padding-right: 15px;
	padding-top: 10px;
	padding-bottom: 5px;
}
</style>

<template>
	<div class="timesheet" @click="$router.push({ name: 'Edit Timesheet', params: { id: timesheet.id }})">
		<div class="timesheet_top"/>
		<v-row 
			class="timesheet_content"
			no-gutters
		>
			<v-col cols="12" class="text-body2 text-truncate">
				{{ timesheet.job.code }}
			</v-col>

			<v-col cols="12" class="text-caption text-truncate">
				{{ timesheet.job.display_name }}
			</v-col>

			<v-col cols="12" class="mt-1 text-caption font-weight-light text-truncate">
				{{ timesheet.kind.display_name }}
			</v-col>

			<v-col
				cols="12" 
				class="text-caption font-weight-light text-truncate" 
				v-if="timesheet.notes!=''"
			>
				{{ timesheet.notes }}
			</v-col>

			<v-col cols="6" class="mt-1 text-caption text-left text-truncate">
				Logged: {{ format_duration(timesheet.duration) }}
			</v-col>
			<v-col cols="6" class="mt-1 text-caption text-right text-truncate">
				Budget: {{ budget }} 
			</v-col>

		</v-row>
	</div>
</template>

<script>
// mixins
import { durationMixin } from "@/mixins/misc/durationMixin"

export default {
	mixins: [ durationMixin ],
	props: {
		timesheet: {
			type: Object,
			default: null
		}
	},
	computed: {
		budget() {
			if (this.timesheet.task == null) {
				return 'n/a';
			} else {
				return this.format_duration(this.timesheet.task.budget);
			}
		}
	}
}
</script>